export default "__VITE_ASSET__DCzDYiE6__"